export default {
  salesCount: (state) => {
    return state.salesCount;
  },
  sumSales: (state) => {
    return state.sumSales;
  },
  salesCountInMonth: (state) => {
    return state.salesCountInMonth;
  },

  visits: (state) => {
    return state.visits;
  },

  mostVisited: (state) => {
    return state.mostVisited;
  },
  mostVisitPerDay: (state) => {
    return state.mostVisitPerDay;
  },
  mostVisitPerHour: (state) => {
    return state.mostVisitPerHour;
  },
  mostVisitPerCountry: (state) => {
    return state.mostVisitPerCountry;
  },

  visitorsList: (state) => {
    return state.visitorsList;
  },

  services: (state) => {
    return state.services;
  },
  service: (state) => {
    return state.service;
  },
  waitingTickets: (state) => {
    return state.waitingTickets;
  },
  answeredTickets: (state) => {
    return state.answeredTickets;
  },
  closedTickets: (state) => {
    return state.closedTickets;
  },
  ticket: (state) => {
    return state.ticket;
  },
  ticketCategories: (state) => {
    return state.ticketCategories;
  },

  brands: (state) => {
    return state.brands;
  },

  brandOptions: (state) => {
    const brandOptions = [];
    state.brands.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      brandOptions.push(pushItem);
    }
    return brandOptions;
  },

  brand: (state) => {
    return state.brand;
  },

  festivalDiscounts: (state) => {
    return state.festivalDiscounts;
  },

  ProductCategoryChilds: (state) => {
    return state.categoryChilds;
  },

  productCategoryChildOptions: (state) => {
    const categoryOptions = [];
    state.categoryChilds.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      categoryOptions.push(pushItem);
    }
    return categoryOptions;
  },

  productFeatures: (state) => {
    return state.productFeatures;
  },

  productFeatureOptions: (state) => {
    const featureOptions = [];
    state.productFeatures.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      featureOptions.push(pushItem);
    }
    return featureOptions;
  },

  productFeaturesByCategory: (state) => {
    return state.productFeaturesByCategory;
  },
  productFeatureByCategoryOptions: (state) => {
    const featureOptions = [];
    state.productFeaturesByCategory.forEach(func);

    function func(item) {
      if (item.isRequired) {
        const pushItem = {
          value: item.featureId,
          text: item.featureTitle + "*",
        };
        featureOptions.push(pushItem);
      } else {
        const pushItem = {
          value: item.featureId,
          text: item.featureTitle,
        };
        featureOptions.push(pushItem);
      }
    }
    return featureOptions;
  },

  productFeatureDetails: (state) => {
    return state.productFeatureDetails;
  },

  ProductFeatureDetailsByFeatureId: (state) => {
    return state.productFeatureDetails;
  },

  productFeatureDetailOptions: (state) => {
    const featureOptions = [];
    state.productFeatureDetails.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      featureOptions.push(pushItem);
    }
    return featureOptions;
  },

  products: (state) => {
    return state.products;
  },

  productOptions: (state) => {
    const productOptions = [];
    state.products.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productOptions.push(pushItem);
    }
    return productOptions;
  },

  product: (state) => {
    return state.product;
  },

  productImages: (state) => {
    return state.productImages;
  },

  outOfStocks: (state) => {
    return state.outOfStocks;
  },

  outOfStockOptions: (state) => {
    const stockOptions = [];
    state.outOfStocks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      stockOptions.push(pushItem);
    }
    return stockOptions;
  },

  newReturns: (state) => {
    return state.newReturns;
  },
  checkedReturns: (state) => {
    return state.checkedReturns;
  },
  factor: (state) => {
    return state.factor;
  },

  contactMessages: (state) => {
    return state.contactMessages;
  },
  newsLetters: (state) => {
    return state.newsLetters;
  },

  team: (state) => {
    return state.team;
  },

  faqs: (state) => {
    return state.faqs;
  },
  faq: (state) => {
    return state.faq;
  },
};
